import { biStrategy } from './biStrategy/biStrategy';
import { experimentStrategy } from './experimentStrategy/experimentStrategy';
import urlResolutionStrategy from './urlResolutionStrategy/urlResolutionStrategy';
import pollsStrategy from './pollsStrategy/pollsStrategy';
import mapStrategy from './mapStrategy/mapStrategy';
import iframeSandboxDomainStrategy from './iframeSandboxDomainStrategy/iframeSandboxDomainStrategy';
import { merge } from 'lodash';
import { parseInstance, hasPlugin as hasPluginInPlugins } from './services';
import { POLL_TYPE, MAP_TYPE } from 'wix-rich-content-common';
var getHttpClientPromise;
var httpClientPromise;
export var runStrategies = function (_a) {
    var _b;
    var experiments = _a.experiments, plugins = _a.plugins, instance = _a.instance, wixRicosVersion = _a.wixRicosVersion, biSettings = _a.biSettings, httpClient = _a.httpClient, _c = _a.msid, msid = _c === void 0 ? '' : _c;
    var hasPlugin = function (pluginType) { return hasPluginInPlugins(pluginType, plugins); };
    var _d = parseInstance(instance), instanceMsid = _d.metaSiteId, appDefId = _d.appDefId;
    var metaSiteId = instanceMsid || msid;
    var _e = experimentStrategy(experiments), ricosFeatures = _e.ricosFeatures, wixRicosFeatures = _e.wixRicosFeatures;
    getHttpClientPromise = function () {
        if (!httpClientPromise)
            httpClientPromise =
                (httpClient && Promise.resolve(httpClient)) ||
                    import('@wix/http-client').then(function (http) { return new http.HttpClient(); });
        return httpClientPromise;
    };
    return merge({ experiments: ricosFeatures }, biStrategy(appDefId, metaSiteId, wixRicosVersion, biSettings, wixRicosFeatures), urlResolutionStrategy(hasPlugin, instance, metaSiteId, wixRicosFeatures), hasPlugin(POLL_TYPE) && pollsStrategy(instance, getHttpClientPromise, wixRicosFeatures), iframeSandboxDomainStrategy(metaSiteId, wixRicosFeatures), ((_b = wixRicosFeatures === null || wixRicosFeatures === void 0 ? void 0 : wixRicosFeatures.mapStrategy) === null || _b === void 0 ? void 0 : _b.enabled) && hasPlugin(MAP_TYPE) && mapStrategy());
};
export var runStrategiesWithCommonUtils = function (props) { return ({
    strategies: runStrategies(props),
    getHttpClientPromise: getHttpClientPromise,
}); };
//# sourceMappingURL=runStrategies.js.map